// Styles
import './VSubheader.sass'

// Mixins
import Themeable from '../../mixins/themeable'
import mixins from '../../util/mixins'

// Types
import { VNode } from 'vue'

export default mixins(
  Themeable
  /* @vue/component */
).extend({
  name: 'v-subheader',

  props: {
    inset: Boolean,
    classPrefix: {
      type: String,
      default: '',
    },
  },

  render (h): VNode {
    return h('div', {
      staticClass: `${this.classPrefix}v-subheader`,
      class: {
        [`${this.classPrefix}v-subheader--inset`]: this.inset,
        ...this.themeClasses,
      },
      attrs: this.$attrs,
      on: this.$listeners,
    }, this.$slots.default)
  },
})
